/* ============================================================
   圖鑑的三欄版面：索引收合 / 檔案抽屜 / 兩段式降級
   ============================================================

   B3 拍板的骨架（2026-08-03）：**索引（可收合）／掃描艙／檔案**。

   | 視窗寬 | 索引 | 檔案 |
   |---|---|---|
   | ≥1280 | 常駐（可手動收） | 常駐 |
   | 980–1280 | 預設收起（可手動展開） | 常駐 |
   | <980 | 預設收起 | **右側滑出的覆蓋層**，掃描艙吃滿寬 |

   兩條刻意的設計：

   1. **手動開合只在同一個斷點內有效。** 跨斷點就把手動狀態丟掉回到預設 ——
      不丟的話，使用者在寬視窗收起索引、縮小視窗、再放大，索引會莫名其妙
      停在收起狀態，而他早就忘了自己收過。
   2. **這個模組不碰鏡頭。** 它只算狀態、掛 class；量 DOM 與同步視錐是
      `ui/codex.ts` 的事（呼叫端負責在改完版面之後 `syncCodexView()`）。
      兩邊都去改鏡頭的話就會出現「版面與鏡頭各寫一份常數」那個坑。 */

import { $ } from '../platform/dom';

/** 目前的版面狀態。`syncCodexView()` 要看 `drawer` —— 覆蓋層不佔版面，
    它的矩形不可以拿去做視錐偏移（否則檔案一拉開，展品就往旁邊跳）。 */
export var LAY = { list: true, drawer: false, dataOpen: false };

var pref: any = null;      // 使用者手動指定過的索引開合（null = 用預設）
var lastNarrow: any = null;

/** 斷點要用**「UI 覺得自己有多寬」**，不是視窗有多寬。
    `#ui` 掛了 `zoom: var(--ui-scale)`（`style.css`），放大 1.15 倍之後
    1024 的視窗對 UI 來說只有 890 —— 拿 `innerWidth` 直接比的話，
    版面會在「其實已經擠爆了」的寬度還維持三欄。 */
function cssScale(name) {
  if (typeof document === 'undefined' || !document.documentElement) return 1;
  var n = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name));
  return n > 0.2 && n < 4 ? n : 1;
}
/** **兩層都要除**：`#ui` 的 `--ui-scale` 與圖鑑自己的 `--codex-scale`。 */
function uiScale() { return cssScale('--ui-scale') * cssScale('--codex-scale'); }

function width() {
  return typeof window === 'undefined' ? 1920 : window.innerWidth / uiScale();
}

/** 重算版面並掛 class。呼叫端改完之後要自己 `syncCodexView()`。 */
export function applyCodexLayout() {
  var w = width(), narrow = w < 1280, tight = w < 980;
  if (narrow !== lastNarrow) { pref = null; lastNarrow = narrow; }
  LAY.list = pref === null ? !narrow : !!pref;
  LAY.drawer = tight;
  if (!tight) LAY.dataOpen = false;

  var el = $('screenCodex');
  if (!el) return;
  el.classList.toggle('list-off', !LAY.list);
  el.classList.toggle('data-drawer', LAY.drawer);
  el.classList.toggle('data-open', LAY.drawer && LAY.dataOpen);
}

export function toggleCodexList() {
  pref = !LAY.list;
  applyCodexLayout();
}

export function toggleCodexData() {
  if (!LAY.drawer) return;
  LAY.dataOpen = !LAY.dataOpen;
  applyCodexLayout();
}

/** 每次開啟圖鑑都回到該尺寸的預設版面。 */
export function resetCodexLayout() {
  pref = null; lastNarrow = null; LAY.dataOpen = false;
  applyCodexLayout();
}
